import { acceptHMRUpdate, defineStore } from 'pinia';
import { useApi } from '@/composables/use-api.ts';
import { CompanyCalendarDayDto } from '@/services/api/calendar-day-api.ts';

interface State {
  dateToCcdList: { [key: string]: CompanyCalendarDayDto[] };
  selectDate: Date;
}

export const useCalendarDayStore = defineStore('calendar-day', {
  state: (): State => {
    return {
      dateToCcdList: {},
      selectDate: new Date(),
    };
  },

  actions: {
    async listAsync(date: string) {
      let ccdList = this.dateToCcdList[date];
      if (!ccdList) {
        const { company } = useApi();

        this.dateToCcdList[date] = ccdList =
          await company.calendarDay.listAsync(date);
      }
      return ccdList;
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCalendarDayStore, import.meta.hot));
}
